import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ACTIONS, EVENTS, SCREENS } from '../../../constants/tracking';
import { useApp } from '../../../contexts/AppContext';
import { useTracking } from '../../../contexts/TrackingContext';
import { useTurnOffEma } from '../../../hooks/mutations/useTurnOffEma';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnterpriseManagedAuthTurnOffModal({
  onTurnedOff,
  onClose
}) {
  const {
    turnOffEma,
    loading,
    error
  } = useTurnOffEma();
  const {
    appId,
    appName
  } = useApp();
  const {
    track
  } = useTracking();
  return /*#__PURE__*/_jsx(ConfirmModal, {
    message: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.advanced.ema.turnOff.title"
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.advanced.ema.turnOff.description"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.advanced.ema.turnOff.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.advanced.ema.turnOff.cancel"
    }),
    ConfirmButton: LoadingButton,
    confirmButtonProps: {
      use: 'danger',
      loading,
      failed: Boolean(error)
    },
    onConfirm: () => void turnOffEma().then(({
      data
    }) => {
      if (data) {
        track(EVENTS.PANEL_INTERACTED, {
          screen: SCREENS.MANAGEMENT_MODAL_PANEL,
          action: ACTIONS.EMA_TURNED_OFF,
          appId,
          appName
        });
        onTurnedOff();
      }
    }),
    onReject: onClose
  });
}